<template>
  <el-dialog
    class="import_result"
    :visible.sync="show"
    :width="importType !== 'community'? '900px': '900px'"
    append-to-body>
    <p slot="title" class="dialog_title">导入结果</p>
    <div class="i_search">
      <el-input
        type="text"
        size="small"
        placeholder="查找小区"
        v-model="condition.name"
        ref="search"
        @focus.once="addKeyupEvent"
      >
        <i
          class="iconfont icon-dingdanxiangqing-sousuo search_btn"
          slot="suffix"
          @click="getImportResultList">
        </i>
      </el-input>
    </div>
    <el-table
      ref="listTable"
      size="mini"
      height="400"
      border
      stripe
      :data="nbhdList"
      :empty-text="isSearch?'暂无结果，换个名称重新试试吧~':'暂无数据'"
      @filter-change="filterChange">
      <el-table-column prop="nbhdGuid" label="小区编码" align="center"></el-table-column>
      <el-table-column prop="name" label="小区名称" align="center"></el-table-column>
      <!-- <el-table-column v-if="importType === 'device'" prop="location" label="小区地址" align="center"></el-table-column> -->
      <el-table-column prop="address" label="行政区" align="center"></el-table-column>
      <template v-if="importType === 'device'">
        <el-table-column prop="equipModel" label="广告位置" align="center"></el-table-column>
        <el-table-column prop="equipNo" label="设备编码" align="center"></el-table-column>
        <el-table-column prop="equipName" label="设备名称" align="center"></el-table-column>
      </template>
      <el-table-column
        prop="status"
        label="状态"
        align="center"
        column-key="status"
        :filters="statusList"
        :filter-method="filterStatusHandler">
      </el-table-column>
    </el-table>
    <Pagination
      class="page_box"
      :autoLoad="false"
      :pagerCount="5"
      :total="pageInfo.total"
      :current-page.sync="pageInfo.pageIndex"
      :size.sync="pageInfo.pageSize"
      @fn-change="getImportResultList">
    </Pagination>
    <div class="i_footer" slot="footer">
      <el-button type="primary" size="mini" class="btn import_btn" :disabled="nbhdList&&nbhdList.length === 0"
                 @click="exportIntelligentNbhdExcel">导出
      </el-button>
      <el-button type="default" size="mini" class="btn close_btn" @click="show = false">关闭</el-button>
    </div>
  </el-dialog>
</template>

<script>
import Pagination from '@/components/Pagination'

import { getNbhdExcelByConditionPage, exportIntelligentNbhdExcel } from '@/utils/api'

export default {
  name: 'ImportResult',
  components: { Pagination },
  props: {
    visible: {
      type: Boolean,
      default: true
    },
    importType: {
      type: String,
      default: 'community'
    },
    uuid: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      condition: {
        name: ''
      },
      pageInfo: {
        pageIndex: 1,
        pageSize: 10,
        total: 0
      },
      nbhdList: [],
      statusList: [{
        text: '导入成功',
        value: '导入成功'
      }, {
        text: '导入失败',
        value: '导入失败'
      }],
      filterOpts: []
    }
  },
  computed: {
    show: {
      get () {
        return this.visible
      },
      set (nv) {
        this.$emit('update:visible', nv)
      }
    },
    isSearch () {
      return !!this.condition.name.trim()
    },
    isImportTypeDevice () {
      return this.importType && this.importType.toLowerCase().indexOf('device') > -1
    }
  },
  watch: {
    visible (nv) {
      if (!nv) return
      this.filterOpts = []
      this.condition = { name: '' }
      this.pageInfo = { pageIndex: 1, pageSize: 10, total: 0 } // 条件重置
      this.getImportResultList()
    },
    'condition.name' (nv) {
      if (!nv.trim()) {
        this.pageInfo = { pageIndex: 1, pageSize: 10, total: 0 }
        this.getImportResultList()
      }
    }
  },
  methods: {
    async getImportResultList () {
      let res = await getNbhdExcelByConditionPage({
        ...this.condition,
        pageIndex: this.pageInfo.pageIndex,
        pageSize: this.pageInfo.pageSize,
        statusList: this.filterOpts,
        uuid: this.uuid,
        importedType: this.isImportTypeDevice ? 3 : 1 // 点位3 小区1
      })
      if (res &&　res.code === 0 && res.data) {
        if (this.$refs.listTable) this.$refs.listTable.clearFilter() // 清空所有过滤条件恢复table数据
        this.nbhdList = res.data.list || []
        this.pageInfo.total = res.data.total
      } else {
        this.nbhdList = []
        this.pageInfo.total = 0
      }
    },
    async exportIntelligentNbhdExcel () {
      let file = await exportIntelligentNbhdExcel({
        ...this.condition,
        pageIndex: this.pageInfo.pageIndex,
        pageSize: this.pageInfo.pageSize,
        uuid: this.uuid,
        type: this.importType === 'device' ? 3 : '',
        statusList: this.filterOpts
      })
      if (!file) return
      this.$blobSaveFile(file, '小区导出.xls')
      this.show = false
    },
    filterStatusHandler (value, row, column) {
      return row.status === value
    },
    filterChange (filters) {
      this.filterOpts = filters.status
      this.pageInfo = { pageIndex: 1, pageSize: 10, total: 0 }
      this.getImportResultList()
    },
    addKeyupEvent () {
      this.$refs.search.$el.addEventListener('keyup', e => {
        if (e.code === 'Enter') {
          this.getImportResultList()
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.import_result {
  ::v-deep .el-dialog__header {
    padding: 12px 10px;
    box-shadow: 0 1px 0 0 #e9e9e9;
  }
  ::v-deep .el-dialog__headerbtn {
    top: 16px;
  }
  ::v-deep .el-dialog__footer {
    box-shadow: 0 -1px 0 0 #e9e9e9;
  }
}
.dialog_title {
  text-align: center;
  color: #282729;
  font-size: 18px;
  line-height: 25px;
}
.i_search {
  width: 240px;
  margin: 0 auto 10px;
  text-align: center;
  ::v-deep .el-input__inner {
    padding-left: 20px;
    border-radius: 15px;
  }
  ::v-deep .el-input__suffix {
    right: 20px;
    .iconfont {
      font-size: 18px;
    }
  }
}
.page_box {
  margin-top: 20px;
}
.i_footer {
  text-align: center;
  .btn {
    width: 120px;
  }
  .import_btn {
    padding: 8px 15px;
    background: linear-gradient(315deg, rgba(255, 132, 109, 1) 0%, rgba(255, 57, 115, 1) 100%);
    border: none;
  }
}
.search_btn {
  line-height: 32px;
  cursor: pointer;
}
.close_btn:hover {
  color: #FF3973 !important;
  background-color: rgba(#FF3973, .1) !important;
  border-color: #FF3973 !important;
}

</style>
